import {
  Alert02Icon,
  AlertCircleIcon,
  SecurityCheckIcon
} from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Show } from "shared/components";
import { cx } from "shared/utils";
import { AuthenticityTone } from "../utils/authenticityTone";

const TONE_STYLES = {
  [AuthenticityTone.SUCCESS]: {
    container: "bg-success-50",
    icon: "text-success-600",
    HugeIcon: SecurityCheckIcon,
    message: "We did not find evidence of tampering / fraud this document"
  },
  [AuthenticityTone.WARNING]: {
    container: "bg-warning-50",
    icon: "text-warning-500",
    HugeIcon: Alert02Icon,
    message:
      "We recommend manually reviewing this document as suspicious signals found"
  },
  [AuthenticityTone.ERROR]: {
    container: "bg-danger-50",
    icon: "text-danger-600",
    HugeIcon: AlertCircleIcon,
    message:
      "Based on the below reason codes, we do not believe this document to be authentic"
  }
};

type AuthenticityScoreAlertProps = {
  tone: AuthenticityTone;
  score?: number | null;
  message?: string;
  issues?: string[];
};

export const AuthenticityScoreAlert = (props: AuthenticityScoreAlertProps) => {
  const { tone, score, message, issues = [] } = props;
  const styles = TONE_STYLES[tone];
  const hasIssues = issues.length > 0;
  const body = message || styles.message;

  return (
    <div
      className={cx(
        "flex w-full flex-col justify-center gap-3 overflow-hidden rounded-lg border border-alpha-100 p-5",
        styles.container
      )}
    >
      <div className="flex w-full items-start gap-3">
        <HugeiconsIcon
          icon={styles.HugeIcon}
          size={24}
          className={cx("shrink-0", styles.icon)}
        />
        <p className="flex-1 text-sm text-content-1000">
          <Show if={typeof score === "number"}>
            <span className="font-medium">Authenticity score {score}/100.</span>
            <br />
          </Show>
          <span className="font-normal">{body}</span>
        </p>
      </div>

      <Show if={hasIssues}>
        <div className="h-px w-full bg-alpha-100" />
        <div className="flex flex-col gap-2">
          {issues.map((issue, index) => (
            <p key={index} className="text-[13px] leading-4 text-content-1000">
              {issue}
            </p>
          ))}
        </div>
      </Show>
    </div>
  );
};
